import {
  SET_SELECTED_ACCOUNT_DETAILS,
  SET_SELECT_CUSTOMER_CLICKED,
  SET_MULTI_ACCOUNT_DASHBOARD_TAB_SELECTED,
} from "constants-lib/actionTypes"

export const setSelectedAccountDetails = (selectedAccountDetails) => ({
  type: SET_SELECTED_ACCOUNT_DETAILS,
  payload: {
    selectedAccountDetails,
  },
})

export const setIsCustomerSelectClicked = (isSelectDDClicked) => ({
  type: SET_SELECT_CUSTOMER_CLICKED,
  payload: { isSelectDDClicked },
})

export const clearSelectedAccountDetails = () => ({
  type: SET_SELECTED_ACCOUNT_DETAILS,
  payload: {
    selectedAccountDetails: {},
  },
})

export const setNewMultiAccountTabSelected = (tabSelected) => ({
  type: SET_MULTI_ACCOUNT_DASHBOARD_TAB_SELECTED,
  payload: { tabSelected },
})

export const resetMultiAccountDetails = () => ({
  type: "RESET_MULTI_ACCOUNT_DETAILS",
})
